import { render, staticRenderFns } from "./IconEllipsisHorizontal.vue?vue&type=template&id=115595ae"
import script from "./IconEllipsisHorizontal.vue?vue&type=script&lang=js"
export * from "./IconEllipsisHorizontal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports